export enum APIEndPoints {
  User = '/api/Users',
  Family = '/api/Family',
  Files = '/api/Files',
  Seclusion = '/api/Seclusion',
  ToDoList = '/api/ToDoList',
  FamilyNotes = '/api/FamilyNotes',
  Professional = "/api/FCProfessional",
  DigitalAssistant = '/api/DigitalAssistant',
  WeatherForecast = '/api/WeatherForecast',
  ContactMessage = '/api/ContactMessage',
  Contact = '/api/Contact',
  MedicalContact = '/api/MedicalContact',
  Location = '/api/Location',
  Calander = '/api/Calendar',
  Emergency = '/api/Emergency',
  GoogleGeoCode = 'https://maps.googleapis.com/maps/api/geocode/json',
  Manage = '/api/Manage',
  Subscription = '/api/Subscription',
  Executor = '/api/Executor',
  PasswordManager = '/api/PasswordManager',
  EmergencyNumber = '/api/EmergencyNumbers',
  Burialchecklist = '/api/BurialChecklist',
  CremationChecklist = '/api/CremationChecklist',
  NewsLetter = '/api/NewsLetter',
  PciSubscription = '/api/PciSubscription',
  EmergencyKitKids = '/api/EmergencySuppliesList',
  BasicEmergencyKit = '/api/BasicEmergencyKit',
  EmergencyPlans = '/api/EmergencyPlans',
  CommuterPlans='/api/CommuterPlans'
}
